import React from "react";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" }
  }
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.15
    }
  }
};

const ProductWhyChoose = ({ heading, desc, points }) => {
  return (
    <section className="product-why-choose-section">
      <div className="container product-why-choose-wrapper">

        {/* LEFT */}
        <motion.div
          className="product-why-choose-left"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h3 className="section-subheading" variants={fadeUp}>
            Why Choose Our Product ?
          </motion.h3>

          <motion.h2 className="section-heading" variants={fadeUp}>
            {heading}
          </motion.h2>

          <motion.p className="section-text" variants={fadeUp}>
            {desc}
          </motion.p>
        </motion.div>

        {/* RIGHT */}
        <motion.div
          className="product-why-choose-right"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <ul>
            {points.map((item, i) => (
              <motion.li key={i} variants={fadeUp}>

                <motion.div
                  className="check-circle"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.3 }}
                  viewport={{ once: true }}
                >
                  <span className="check-icon">✓</span>
                </motion.div>

                {item}
              </motion.li>
            ))}
          </ul>
        </motion.div>

      </div>
    </section>
  );
};

export default ProductWhyChoose;